import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Constants from "./Constants";
import Advisors from "./Advisors";
import SchoolInfo from "./SchoolInfo";
import LogoutModal from "./modals/LogoutModal";
import {
	Box,
	Typography,
	Grid,
	Card,
	useTheme,
	IconButton,
	Menu,
	MenuItem,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import Axios from "axios";
import { setInfo } from "./store/actions";
import EditSchoolModal from "./modals/EditSchoolModal";
import WebAppSliderModal from "./modals/WebAppSliderModal";
import League from "./modals/League";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import EventIcon from "@mui/icons-material/Event";
import PasswordIcon from "@mui/icons-material/Password";
import SchoolIcon from "@mui/icons-material/School";
import ResetPassModal from "./modals/ResetPassModal";
import ClassManagement from "./modals/ClassManagement";

function Admin(props) {
	const theme = useTheme();
	const { setAuth } = props;
	const schoolName = useSelector(state => {
		if (
			Object.keys(state.info).length === 0 &&
			state.info.constructor === Object
		) {
			return "";
		} else {
			return state.info.name;
		}
	});
	const [openLogoutModal, setOpenLogoutModal] = useState(false);
	const [logoutMsg, setLogoutMsg] = useState(false);
	const [loading, setLoading] = useState(false);

	const logout = async () => {
		setLoading(true);
		try {
			let logoutResponse = await Axios.get(Constants.baseUrl + "/school/logout", {
				headers: {
					authorization: "Bearer " + localStorage.getItem("schoolToken"),
				},
			});
			const status = logoutResponse.data.status;
			if (status === 202) {
				setLogoutMsg({
					type: true,
					header: "عملیات با موفقیت انجام شد",
					message: logoutResponse.data.result.message,
				});
				setLoading(false);
				localStorage.removeItem("schoolToken");
				setAuth(false);
				window.location.reload();
			} else {
				setLogoutMsg({
					type: false,
					header: "تلاش ناموفق",
					message: logoutResponse.data.result.message,
				});
				setLoading(false);
			}
		} catch (err) {
			setLogoutMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط. مجدد تلاش کنید",
			});
			setLoading(false);
		}
	};

	// school info states
	const dispatch = useDispatch();
	const info = useSelector(state => state.info);
	const [editMsg, setEditMsg] = useState(null);
	const [fetchStatus, setFetchStatus] = useState(0);
	const [loadingFetch, setLoadingFetch] = useState(false);
	const [error, setError] = useState({
		header: "",
		message: "",
	});
	const [open, setOpen] = useState(false);
	const [leagueOpen, setLeagueOpen] = useState(false);
	const [sliderOpen, setSliderOpen] = useState(false);
	const [resetPassOpen, setResetPassOpen] = useState(false);
	const [classManageOpen, setClassManageOpen] = useState(false);

	// menu
	const [anchorEl, setAnchorEl] = React.useState(null);
	const openMenu = Boolean(anchorEl);
	const handleMenuItem = num => {
		if (num === 1) {
			setOpen(true);
		} else if (num === 2) {
			setSliderOpen(true);
		} else if (num === 3) {
			setClassManageOpen(true);
		} else if (num === 4) {
			setResetPassOpen(true);
		} else if (num === 5) {
			setLeagueOpen(true);
		} else {
			setOpenLogoutModal(true);
		}
		setAnchorEl(null);
	};

	const editApi = async info => {
		const data = {
			school: {
				name: info.name,
				city: info.city,
				address: info.address,
				tel: info.tel,
				mail: info.mail,
				website: info.website,
				telegram: info.telegram,
				instagram: info.instagram,
				domain: info.domain,
				description: info.description,
			},
		};
		try {
			const response = await Axios.patch(Constants.baseUrl + "/school/", data, {
				headers: {
					authorization: "Bearer " + localStorage.getItem("schoolToken"),
				},
			});
			const status = response.data.status;
			if (status === 202) {
				fetchData();
				setEditMsg({
					type: true,
					header: "عملیات با موفقیت انجام شد",
					message: "اطلاعات مدرسه ویرایش شد",
				});
			} else {
				setEditMsg({
					type: false,
					header: "تلاش ناموفق",
					message: response.data.result.message,
				});
			}
		} catch (err) {
			setEditMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
		}
	};

	const fetchData = async () => {
		try {
			setLoadingFetch(true);
			const response = await Axios.get(Constants.baseUrl + "/school/profile", {
				headers: {
					authorization: "Bearer " + localStorage.getItem("schoolToken"),
				},
			});
			if (response.data.status === 202) {
				setFetchStatus(0);
				dispatch(setInfo(response.data.result.user));
				setLoadingFetch(false);
			} else {
				setFetchStatus(1);
				setLoadingFetch(false);
				setError({
					header: "خطا از طرف سرور",
					message: response.data.result.message,
				});
			}
		} catch (err) {
			setFetchStatus(2);
			setLoadingFetch(false);
			setError({
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
		}
	};

	return (
		<Box width={"100%"}>
			<Box
				sx={{
					height: "80px",
					backgroundColor: "#fb7d79",
					px: 3,
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}>
				<Box width={"120px"} height={"80px"}>
					<img
						alt="schoolImage"
						src={Constants.baseUrl + "/user/avatar/" + info.avatar}
						style={{
							width: "100%",
							height: "100%",
							objectFit: "contain",
						}}
					/>
				</Box>
				<Box className="d-flex">
					<Typography
						fontSize={"20px"}
						fontWeight={"bold"}
						ml={1.5}
						sx={{ [theme.breakpoints.down("md")]: { fontSize: "18px" } }}>
						پنل مدیریت {schoolName}
					</Typography>
					<IconButton onClick={e => setAnchorEl(e.currentTarget)}>
						<MoreVertIcon fontSize="large" />
					</IconButton>
					<Menu
						anchorEl={anchorEl}
						open={openMenu}
						onClose={() => setAnchorEl(null)}>
						{[
							{
								id: 1,
								title: "ویرایش اطلاعات",
								icon: <EditIcon fontSize="small" />,
							},
							{
								id: 2,
								title: "ویرایش تبلیغات",
								icon: <AddPhotoAlternateIcon fontSize="small" />,
							},
							{
								id: 3,
								title: "مدیریت کلاس",
								icon: <SchoolIcon fontSize="small" />,
							},
							{
								id: 4,
								title: "تغییر رمز عبور",
								icon: <PasswordIcon fontSize="small" />,
							},
							{
								id: 5,
								title: "لیگ هفتگی",
								icon: <EventIcon fontSize="small" />,
							},
							{
								id: 6,
								title: "خروج",
								icon: <LogoutIcon fontSize="small" />,
							},
						].map(item => (
							<MenuItem key={item.id} onClick={() => handleMenuItem(item.id)}>
								{React.cloneElement(item.icon, {
									sx: { ml: 1 },
								})}
								<Typography sx={{ ml: 5 }}>{item.title}</Typography>
							</MenuItem>
						))}
					</Menu>
				</Box>
			</Box>
			<Grid
				container
				spacing={1}
				mt={0.5}
				p={1}
				justifyContent={"space-around"}
				width={"100%"}>
				<Grid
					item
					xs={12}
					lg={8.5}
					sx={{ [theme.breakpoints.down("lg")]: { order: 2 } }}>
					<Card sx={{ p: 2 }}>
						<Advisors />
					</Card>
				</Grid>
				<Grid item xs={12} sm={10} md={8} lg={3}>
					<Card sx={{ p: 2 }}>
						<SchoolInfo
							info={info}
							fetchStatus={fetchStatus}
							error={error}
							fetchData={fetchData}
							loadingFetch={loadingFetch}
						/>
					</Card>
				</Grid>
			</Grid>
			<LogoutModal
				open={openLogoutModal}
				setOpen={setOpenLogoutModal}
				loading={loading}
				logoutApi={logout}
				logoutMsg={logoutMsg}
				setLogoutMsg={setLogoutMsg}
			/>
			<EditSchoolModal
				open={open}
				setOpen={setOpen}
				info={info}
				fetchData={fetchData}
				editApi={editApi}
				msg={editMsg}
				setMsg={setEditMsg}
			/>
			<WebAppSliderModal
				open={sliderOpen}
				setOpen={setSliderOpen}
				domain={info.domain}
			/>
			<ResetPassModal
				open={resetPassOpen}
				setOpen={setResetPassOpen}
				infoUsername={info.username}
				fetchData={fetchData}
			/>
			<ClassManagement classManageOpen={classManageOpen} setClassManageOpen={setClassManageOpen} />
			<League open={leagueOpen} setOpen={setLeagueOpen} />
		</Box>
	);
}

export default Admin;
